export default function initCookiePolicy() {
  const cookiePolicy = document.getElementById('cookie-policy')

  if (!cookiePolicy || cookiePolicy.dataset.initialized === 'true') {
    return
  }

  cookiePolicy.dataset.initialized = 'true'

  const dismissCookie = cookiePolicy.dataset.cookiePolicyCookie || 'cookie-policy-dismissed'
  const acceptButtons = cookiePolicy.querySelectorAll('.js-cookie-consent-agree')
  const openButtons = document.querySelectorAll('.js-open-cookie-policy')
  const cookieStore = window.Cookies ?? Window.Cookies

  const showBanner = () => {
    cookiePolicy.hidden = false
    cookiePolicy.classList.add('show')
  }

  const hideBanner = () => {
    cookiePolicy.classList.remove('show')
    cookiePolicy.hidden = true
  }

  if (cookieStore?.get(dismissCookie)) {
    hideBanner()
  } else {
    showBanner()
  }

  acceptButtons.forEach((button) => {
    button.addEventListener('click', () => {
      cookieStore?.set(dismissCookie, '1', {
        expires: 365,
        sameSite: 'Lax',
        secure: window.location.protocol === 'https:',
      })

      hideBanner()
    })
  })

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      showBanner()
    })
  })
}
